"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2086],{

/***/ 572086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideFLoatingButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/FloatingButton/SideFloating/SideFloatingButton.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 1rem;\n  font-size: 1rem;\n  padding: 1.5rem 1rem;\n  position: fixed;\n  cursor: pointer;\n  top: 50%;\n  z-index: 99;\n  transform: rotate(-90deg);\n  outline: none;\n  border: none;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  ::after {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n  & svg {\n    fill: currentColor;\n  }\n  & svg path {\n    fill: currentColor;\n  }\n\n  transform-origin: top right;\n  white-space: nowrap;\n\n  @media screen and (min-width: 768px) {\n    &.btn_side_floating_cfe {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n    &.btn_side_floating_builder {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n    &.btn_side_floating_preview_desktop {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n    &.btn_side_floating_preview_mobile {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n  }\n  @media screen and (min-width: 1441px) {\n    &.btn_side_floating_cfe {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n    &.btn_side_floating_builder {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n  }\n  @media screen and (max-width: 767px) {\n    &.btn_side_floating_cfe {\n      padding: 1rem;\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n    &.btn_side_floating_builder {\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n  }\n  @media screen and (max-width: 424px) {\n    &.btn_side_floating_cfe {\n      padding: 1rem;\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n  }\n  @media screen and (max-width: 324px) {\n    &.btn_side_floating_cfe {\n      padding: 1rem;\n      right: ",
        ";\n      left: ",
        ";\n      transform: ",
        ";\n      transform: rotate(-90deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SideFloatingButtonWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SideFloatingButtonWrapper",
    componentId: "sc-96d83a82-0"
})(_templateObject(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.borderRadius;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.backgroundHoverColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "4.6%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "25.6px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "395px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "6.9%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "41.4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "2.6%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "25.6px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "395px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "2.2%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "11.8%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "0%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(0, -50%) scale(-1) " : "translate(0, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "395px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "7.5%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(-50%, -50%) scale(-1)" : "translate(-50%, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "12%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "0%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(0, -50%) scale(-1) " : "translate(0, -50%) ";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "15.7%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "0%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "translate(0, -50%) scale(-1) " : "translate(0, -50%) ";
});

// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var utils_common = __webpack_require__(737179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(842757);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/FloatingButton/SideFloating/SideFLoatingButton.js








var SideFloatingButton = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var dispatch = (0,es/* useDispatch */.I0)();
    var openForm = function() {
        dispatch((0,common/* toggleFormWidget */.Aq)(true));
    };
    var ref11 = (0,react.useState)((0,utils_common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.enquiryForm) === null || ref1 === void 0 ? void 0 : ref1.config)), floatingButtonState = ref11[0], setFloatingButtonState = ref11[1];
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref12 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template), propStyle = ref12[0], setPropStyle = ref12[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.style_template
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        setFloatingButtonState((0,utils_common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.enquiryForm) === null || ref1 === void 0 ? void 0 : ref1.config));
    }, [
        props
    ]);
    return (floatingButtonState === null || floatingButtonState === void 0 ? void 0 : (ref4 = floatingButtonState.EnquiryForm) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.config) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.btnText) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SideFloatingButtonWrapper, {
        themeConfig: propStyle,
        styleConfig: floatingButtonState === null || floatingButtonState === void 0 ? void 0 : (ref7 = floatingButtonState.EnquiryForm) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.styleConfig) === null || ref8 === void 0 ? void 0 : ref8.alignment,
        onClick: function() {
            return openForm();
        },
        className: "".concat((props === null || props === void 0 ? void 0 : props.inBuilder) && (props === null || props === void 0 ? void 0 : props.showPreview) ? "btn_side_floating_builder" : "btn_side_floating_preview_".concat(props === null || props === void 0 ? void 0 : props.device), " ").concat((props === null || props === void 0 ? void 0 : props.inBuilder) === false && (props === null || props === void 0 ? void 0 : props.showPreview) === undefined ? "btn_side_floating_cfe" : ""),
        children: floatingButtonState === null || floatingButtonState === void 0 ? void 0 : (ref9 = floatingButtonState.EnquiryForm) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.config) === null || ref10 === void 0 ? void 0 : ref10.btnText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var SideFLoatingButton = (SideFloatingButton);


/***/ })

}]);